<div *ngIf="isLoading" class="loading-container">
  <mat-spinner diameter="50"></mat-spinner>
  <p>Loading blood reports...</p>
</div>

<table mat-table [dataSource]="dataSource" *ngIf="!isLoading">

  <ng-container matColumnDef="reportGeneratedAt">
    <th mat-header-cell *matHeaderCellDef> Date Generated </th>
    <td mat-cell *matCellDef="let element">{{formatDate(element.reportGeneratedAt)}}</td>
  </ng-container>
  
  <ng-container matColumnDef="labBloodReport">
    <th mat-header-cell *matHeaderCellDef> Lab Blood Report </th>
    <td mat-cell *matCellDef="let row" style="padding: 10px; text-align: center;">
      <button (click)="viewLabBloodReport(row.pdfFile)" class="memberDashboard1" [disabled]="!row.pdfFile?.pdfData">
        View
      </button>
    </td>
  </ng-container>
  
  <ng-container matColumnDef="bloodReportAnalysisUrl">
    <th mat-header-cell *matHeaderCellDef> Analysis Report </th>
    <td mat-cell *matCellDef="let row" style="padding: 10px; text-align: center;">
      <a [href]="row.bloodReportAnalysisUrl" target="_blank" rel="noopener noreferrer" class="memberDashboard1">
        View
      </a>
    </td>
  </ng-container>
  
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
<div style="text-align:center;display:flex;" *ngIf="!isLoading">
  <mat-paginator #paginator
                 (page)="pageChangeEvent($event)"
                 [length]="this.totalRecords"
                 [pageSize]="pageSize"
                 [pageIndex]="pageIndex"
                 showFirstLastButton>
  </mat-paginator>
</div>
